import { ControlFacet, childControlOption } from '../models/controls/ControlFacet';
import { ICommand } from '../models/commands/ICommand';
import { Omit } from '../utilities/Omit';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IComponentAs } from '@uifabric/utilities/lib/IComponentAs';

/**
 * @beta
 */
export interface IItemsViewBaseProps {
  itemKey: string | undefined;
  layoutHandlerKey?: string;
}

/**
 * @beta
 */
export interface IItemsViewLayoutControlProps {
  itemKey: string | undefined;
  itemsScopeItemKey: string;
  layoutHandlerKey: string;
}

/**
 * @beta
 */
export interface IItemsViewLayoutProps {
  itemKey: string | undefined;
}

/**
 * @beta
 */
export interface IItemsViewLayoutControlOverrides {
  layout: React.ComponentType<IItemsViewLayoutProps>;
}

/**
 * @beta
 */
export type IItemsViewLayoutHandlerCommand = Omit<ICommand, 'onRender' | 'action' | 'key'>;

/**
 * @beta
 */
export const itemsViewLayoutHandlerControl = new ControlFacet<
  IItemsViewLayoutControlProps, IItemsViewLayoutControlOverrides
  >('itemsViewLayoutControl');

/**
 * @beta
 */
export interface IItemsViewLayoutHandler {
  key: string;
  command: IItemsViewLayoutHandlerCommand;
  controlHandler: typeof itemsViewLayoutHandlerControl.type;
}

/**
 * @beta
 */
export interface IItemsViewBetaControlProps {
  itemsScopeItemKey: string;
  itemKey: string | undefined;
}

/**
 * @beta
 */
export interface IItemsViewBetaControlOverrides {
  /**
   * Override for the layout handlers permitted for the given item.
   * In general, handlers of this control should concatenate new entries with the current overrides,
   * and avoid removing or comletely overriding existing entries.
   */
  layoutHandlers: IItemsViewLayoutHandler[];
  layoutControlHandler: typeof itemsViewLayoutHandlerControl.type;
  /**
   * Override for the rendering of ItemsView.
   * In general, use this to wrap the presentation of the layout with additional components, such as pinned items,
   * or with control handlers to alter the behavior of the list.
   */
  itemsViewAs: IComponentAs<IItemsViewBaseProps>;
}

/**
 * @beta
 */
export const itemsViewBetaControl = new ControlFacet<IItemsViewBetaControlProps, IItemsViewBetaControlOverrides>('itemsViewBetaControl', {
  layoutControlHandler: childControlOption(itemsViewLayoutHandlerControl),
  itemsViewAs: defaultRenderComponentOption<IItemsViewBaseProps>()
});
